import { availableFeaturesFlags } from '../constants'

/**
 * Checks if a given feature flag is enabled.
 *
 * @param {string} featureFlag - The name of the feature flag to check.
 * @return {boolean} Returns true if the feature flag is enabled, false otherwise.
 */
function isFFEnabled(featureFlag) {
  if (!_featureFlagExist(featureFlag)) {
    // we have miss to remove a flag in code so this make it pass but :
    // should we log this somewhere ? weak against typo ?
    return true
  }

  const enabledFeatures = window.localStorage.getItem('flags')

  if (!enabledFeatures) {
    return false
  }

  const flags = enabledFeatures.split(',')

  return flags.indexOf(featureFlag) !== -1
}

/**
 * Checks if a given feature flag exists in the availableFeaturesFlags array.
 *
 * @param {string} featureFlag - The feature flag to check for existence.
 * @return {boolean} Returns true if the feature flag exists, false otherwise.
 */
function _featureFlagExist(featureFlag) {
  return availableFeaturesFlags.findIndex((flag) => flag === featureFlag) !== -1
}

/**
 * Adds a feature flag to the list of enabled flags.
 *
 * @param {string} flag - The feature flag to be added.
 * @return {Array} - The updated list of enabled feature flags.
 */
function addFeatureFlag(flag) {
  if (isFFEnabled(flag)) {
    return
  }

  const newFlagsArray = [...getFeatureFlags(), flag]

  _setFeatureFlags(newFlagsArray)

  return newFlagsArray
}

/**
 * Removes a feature flag from the list of enabled feature flags.
 *
 * @param {string} flag - The feature flag to remove.
 * @return {Array} - The updated list of enabled feature flags.
 */
function removeFeatureFlag(flag) {
  if (!isFFEnabled(flag)) {
    return
  }

  const newFlagsArray = getFeatureFlags().filter((f) => flag !== f)

  _setFeatureFlags(newFlagsArray)

  return newFlagsArray
}

/**
 * Sets the feature flags in the local storage.
 *
 * @param {Array} flagsArray - An array of feature flags.
 */
function _setFeatureFlags(flagsArray) {
  window.localStorage.setItem('flags', flagsArray.join(','))
}

/**
 * Retrieves the feature flags from the local storage.
 *
 * @return {Array} An array of feature flags.
 */
function getFeatureFlags() {
  const strigifiedFlags = window.localStorage.getItem('flags')

  return strigifiedFlags ? strigifiedFlags.split(',') : []
}

const featureFlag = {
  isFFEnabled,
  getFeatureFlags,
  addFeatureFlag,
  removeFeatureFlag,
}

const VueFeatureFlags = {
  install(Vue, _options) {
    Vue.prototype.$featureFlags = featureFlag
  },
}

export default VueFeatureFlags
